import React from "react"

const Wrapper = ({children, parent, ...props }) => {
    
    return React.createElement(parent, props, children)

}

export default Wrapper